import styled from '@emotion/styled'
import {IconButton} from '@mui/material'
export const ErrorElement = styled('a')(({theme}) => ({
  color: theme.palette.hpPrimaryDark,
  textDecoration: 'none'
}))

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  '& .MuiSvgIcon-root': {
    color: theme.palette.hpAccentBlack
  }
}))
